angular.module('labApp').component('sampleAssessed', {
    bindings: {
        sample: '<'
    },
    templateUrl: '/static/assets/khapps/lab/samples_and_results/sample_list/sample-assessed.component.html',
    controller: function (KisanHubIconsResource) {
        this.icons = KisanHubIconsResource.khIcons;
    }
});